import Section from "@/components/Section";
import { Box, Container, Typography, useTheme } from "@mui/material";
import CarLineIcon from "@/assets/icons/solutions/car-line.svg?react";
import CarIcon from "@/assets/icons/solutions/car.svg?react";
import VehicleTrackersSection from "./components/VehicleTrackersSection";
import AdvantagesSection from "./components/AdvantagesSection";
import HelpSection from "./components/HelpSection";
import useResponsive from "@/hooks/useResponsive";
import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";

const Solutions = () => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "md");
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 3, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <Section
        pt={{ xs: 0, lg: 10 }}
        pb={{ xs: 11, lg: 21 }}
        sectionSx={{
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            position: "relative",
          }}
        >
          <Typography
            variant="h1"
            color={theme.palette.grey[800]}
            sx={{
              maxWidth: "965px",
            }}
          >
            Unmatched Precision, Superior Performance, and Cutting-Edge Innovation in Every Device
          </Typography>
          <Typography
            variant="subtitle1"
            component="p"
            color={theme.palette.grey[600]}
            sx={{
              maxWidth: "513px",
              alignSelf: { xs: "start", md: "end" },
            }}
          >
            Trackmate's GPS tracking devices for vehicles and assets are designed for effortless installation 
            and seamless integration with our advanced management platform.
          </Typography>
        </Box>
        <Box
          sx={{
            position: "absolute",
            bottom: { xs: "-150px", md: "-110px", lg: "-60px" },
            right: { xs: "-550px", lg: "-65px" },
          }}
        >
          <CarLineIcon />
          <Box
            sx={{
              position: "absolute",
              top: { xs: "-30px", md: "-48px" },
              left: { xs: "700px", lg: "800px" },
            }}
          >
            <CarIcon
              width={isMobile ? "60px" : "96px"}
              height={isMobile ? "60px" : "96px"}
            />
          </Box>
        </Box>
      </Section>
      <VehicleTrackersSection />
      <AdvantagesSection />
      <HelpSection />
    </>
  );
};

export default Solutions;
